import { GreenCircleCheckmark } from '../../../../svg/GreenCircleCheckmark';

export const UpdateConfirmedContent = () => {
  return (
    <div className='flex flex-col gap-8 md:mt-8 justify-center items-center md:w-[500px]'>
      <GreenCircleCheckmark size={150} />
      <div className='text-center text-lg'>
        Thanks for the update! We'll follow up with you via email soon.
      </div>
    </div>
  );
};
